export default "__VITE_ASSET__o4PXhJEZ__"